import React from "react";
import TextPlusImageCard from "../../components/sections/TextPlusImageCard";
import DividersInfoSection from "../../components/sections/DividersInfoSection";
import FooterSection from "../../components/sections/FooterSection";
import { useTranslation } from "react-i18next";

/**
 * Page about why should visitor choose Jai International
 * @param {*} props 
 * @returns 
 */
function WhyJaiPage(props) {

    var { t } = useTranslation();

    return (
        <>
            {/* HERO SECTION — full-width using UIKit */}
            <div className="uk-section uk-section-primary uk-light uk-section-expand uk-flex uk-flex-middle"
                style={{ backgroundImage: "url('/imgvideo/pano1.jpg')", backgroundSize: "cover", backgroundPosition: "center" }}>
                <div className="uk-container uk-container-expand">
                    <div className="uk-width-2-3@m">
                        <h1 className="uk-heading-medium uk-text-glow uk-animation-slide-left">
                            {t("infopages.why_jai.hero1", { defaultValue: "Your Trusted Partner for Kazakhstan Visas" })}
                        </h1>
                        <p className="uk-text-lead uk-margin-top uk-text-glow uk-animation-fade">
                            {t("infopages.why_jai.hero2", { defaultValue: "Jai guides every applicant with accuracy, transparency, and efficiency — ensuring confidence through each step of the Kazakh visa process." })}
                        </p>
                        <a href="#whyjai" className="uk-button uk-button-jai uk-margin-top">
                            {t("infopages.why_jai.cta1", { defaultValue: "Why Choose Jai" })}
                        </a>
                    </div>
                </div>
            </div>

            <TextPlusImageCard
                order="left"
                title={t("infopages.why_jai.block1.1")}
                fatText={t("infopages.why_jai.block1.2")}
                thinText={t("infopages.why_jai.block1.3")}
                cta={t("infopages.why_jai.block1.5")}
                imageAlt={t("infopages.why_jai.block1.4")}
                imageFrameText={t("infopages.why_jai.block1.4")}
                imageURL="https://informburo.kz/storage/photos/oldArticle/main/fv2FZpfPKmJXq0XC.jpg"
            />

            <TextPlusImageCard
                order="right"
                title={t("infopages.why_jai.block2.1")}
                fatText={t("infopages.why_jai.block2.2")}
                thinText={t("infopages.why_jai.block2.3")}
                cta={t("infopages.why_jai.block2.5")}
                imageAlt={t("infopages.why_jai.block2.4")}
                imageFrameText={t("infopages.why_jai.block2.4")}
                imageURL="https://cdn.nur.kz/images/1200x675/8c16ab881162b94b.jpeg?version=1"
            />

            <TextPlusImageCard
                order="left"
                title={t("infopages.why_jai.block3.1")}
                fatText={t("infopages.why_jai.block3.2")}
                thinText={t("infopages.why_jai.block3.3")}
                cta={t("infopages.why_jai.block3.5")}
                imageAlt={t("infopages.why_jai.block3.4")}
                imageFrameText={t("infopages.why_jai.block3.4")}
                imageURL="/imgvideo/backstage.jpg"
            />

            <TextPlusImageCard
                order="right"
                title={t("infopages.why_jai.block4.1")}
                fatText={t("infopages.why_jai.block4.2")}
                thinText={t("infopages.why_jai.block4.3")}
                cta={t("infopages.why_jai.block4.5")}
                imageAlt={t("infopages.why_jai.block4.4")}
                imageFrameText={t("infopages.why_jai.block4.4")}
                imageURL="https://korgalzhyn.kz/userdata/photos/photos_62/image_b.jpg"
            />

            <TextPlusImageCard
                order="left"
                title={t("infopages.why_jai.block5.1")}
                fatText={t("infopages.why_jai.block5.2")}
                thinText={t("infopages.why_jai.block5.3")}
                cta={t("infopages.why_jai.block5.5")}
                imageAlt={t("infopages.why_jai.block5.4")}
                imageFrameText={t("infopages.why_jai.block5.4")}
                imageURL="https://media.istockphoto.com/id/1130785257/ru/%D1%84%D0%BE%D1%82%D0%BE/%D0%B1%D0%B8%D0%BE%D0%BC%D0%B5%D1%82%D1%80%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B9-%D0%BF%D0%B0%D1%81%D0%BF%D0%BE%D1%80%D1%82-%D1%81-%D1%82%D1%83%D1%80%D0%B8%D1%81%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B9-%D0%B2%D0%B8%D0%B7%D0%BE%D0%B9-%D1%88%D1%82%D0%B0%D0%BC%D0%BF-%D0%B4%D0%BB%D1%8F-%D1%81%D1%88%D0%B0.jpg?s=612x612&w=0&k=20&c=YBoXCcYMSmWez8IwxOxSNtjZYc4UpYeUVPPKG_ddTEI="
            />

            <TextPlusImageCard
                order="right"
                title={t("infopages.why_jai.block6.1")}
                fatText={t("infopages.why_jai.block6.2")}
                thinText={t("infopages.why_jai.block6.3")}
                cta={t("infopages.why_jai.block6.5")}
                imageAlt={t("infopages.why_jai.block6.4")}
                imageFrameText={t("infopages.why_jai.block6.4")}
                imageURL="https://invest.gov.kz/upload/iblock/915/obgcpok339itl03xpeo6nmk1qpgbwcit.jpg"
            />


            {/* TRUST / WHY JAI SECTION — full width */}
            <div id="whyjai" className="uk-section uk-section-muted">
                <div className="uk-container uk-text-center">
                    <h2 className="uk-heading-medium uk-margin-large-bottom uk-animation-fade">
                        {t("infopages.why_jai.tiles")}
                    </h2>

                    <div className="uk-child-width-1-2@m uk-grid-large uk-grid-match uk-margin-large-bottom" data-uk-grid>
                        <div>
                            <div className="uk-card uk-card-default uk-card-body uk-card-hover uk-animation-slide-left">
                                <h3 className="uk-card-title">
                                    {t("infopages.why_jai.tile1_header")}
                                </h3>
                                <p>
                                    {t("infopages.why_jai.tile1_text")}
                                </p>
                            </div>
                        </div>
                        <div>
                            <div className="uk-card uk-card-default uk-card-body uk-card-hover uk-animation-slide-right">
                                <h3 className="uk-card-title">
                                    {t("infopages.why_jai.tile2_header")}
                                </h3>
                                <p>
                                    {t("infopages.why_jai.tile2_text")}
                                </p>
                            </div>
                        </div>
                        <div>
                            <div className="uk-card uk-card-default uk-card-body uk-card-hover uk-animation-slide-left">
                                <h3 className="uk-card-title">
                                    {t("infopages.why_jai.tile3_header")}
                                </h3>
                                <p>
                                    {t("infopages.why_jai.tile3_text")}
                                </p>
                            </div>
                        </div>
                        <div>
                            <div className="uk-card uk-card-default uk-card-body uk-card-hover uk-animation-slide-right">
                                <h3 className="uk-card-title">
                                    {t("infopages.why_jai.tile4_header")}
                                </h3>
                                <p>
                                    {t("infopages.why_jai.tile4_text")}
                                </p>
                            </div>
                        </div>
                    </div>

                    <p className="uk-text-large uk-width-2-3@m uk-margin-auto uk-animation-fade">
                        {t("infopages.why_jai.tiles_outro")}
                    </p>
                </div>
            </div>
            
            <div className="uk-container uk-margin-top uk-margin-bottom">
                <DividersInfoSection />
            </div>

            {/* CTA — full width */}
            <div className="uk-section uk-section-primary uk-section-expand uk-light uk-text-center">
                <div className="uk-container uk-container-expand">
                    <h2 className="uk-heading-medium uk-animation-slide-bottom">
                        {t("infopages.why_jai.ctahead", { defaultValue: "Take the First Step with Confidence" })}
                    </h2>
                    <p className="uk-text-lead uk-margin-top uk-animation-fade">
                        {t("infopages.why_jai.ctatext", { defaultValue: "Kazakhstan welcomes aspiring students and professionals. With Jai, complex procedures become clear, structured, and predictable." })}
                    </p>
                    <a href="/apply-visa" className="uk-button uk-button-secondary uk-button-large uk-margin-top uk-animation-slide-bottom">
                        {t("infopages.why_jai.ctalink", { defaultValue: "Contact Experts" })}
                    </a>
                </div>
            </div>

            <FooterSection />
        </>
    );
}

export default WhyJaiPage;
